import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AusstallenService } from '../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import {
    GruppeTier,
    GruppeTierBemerkung,
} from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { GruppeTierFilterButtonComponent } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/filter/gruppe-tier-filter-button/gruppe-tier-filter-button.component';
import { TierFilterSettings } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/filter/gruppe-tier-filter-dialog/classes/tier-filter-settings';
import { TierFilterSettingsPersistence } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/filter/gruppe-tier-filter-dialog/classes/tier-filter-settings-persistence';
import { GruppeTierBemerkungDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-bemerkung-dialog/gruppe-tier-bemerkung-dialog.component';
import { GruppeTierDetailsDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-details-dialog/gruppe-tier-details-dialog.component';
import { GruppeTierPassScanVerwaltungDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-pass-scan-verwaltung-dialog/gruppe-tier-pass-scan-verwaltung-dialog.component';
import { GruppeTierService } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import {
    EinstallenMeldenDialogInput,
    EinstallenMeldenDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/einstallen-melden';

import { Gruppe, GruppenStatistik } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenVerlauf } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppen-verlauf';
import { AbgangDownloadRequestPojo } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang-download-dialog/gruppe-abgang-download-dialog';
import { GruppeAbgangDownloadDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang-download-dialog/gruppe-abgang-download-dialog.component';
import { EinstallenMeldenDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen-melden-dialog/einstallen-melden-dialog.component';
import { GruppeReklamationPdfHaendlerAuswahlDialogOutput } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-reklamation-pdf-haendler-auswahl-dialog/classes/gruppe-reklamation-pdf-haendler-auswahl-dialog-output';
import { GruppeReklamationPdfHaendlerAuswahlDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-reklamation-pdf-haendler-auswahl-dialog/gruppe-reklamation-pdf-haendler-auswahl-dialog.component';
import { GruppeStandortWechselnDialogResult } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog-result';
import { GruppeStandortWechselnDialogComponent } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog.component';
import { GruppenService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import { GruppeAbgangService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/gruppe-abgang.service';
import { EinstallenService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-einstallen/einstallen.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { AppService } from '../../../../projects/kiene-core/src/lib/services/app/app.service';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableComponent } from '../../components/kiene-table/kiene-table.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ArrayTableColumn,
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    KieneBooleanTableColumn,
    NumberTableColumn,
    OhrmarkeTableColumn,
    TableColumn,
    TextTableColumn,
} from '../../components/kiene-table/table-column';
import { SelectionToolbarButton, TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import {
    TexteingabeDialogComponent,
    TexteingabeResult,
} from '../../dialogs/texteingabe-dialog/texteingabe-dialog.component';
import { FileDownloadService } from '../../services/file-download.service';
import { AddGruppeTierReklamationDialogComponent } from '../add-gruppe-tier-reklamation-dialog/add-gruppe-tier-reklamation-dialog.component';
import { GruppeInformationenDialogComponent } from '../gruppe-informationen-dialog/gruppe-informationen-dialog.component';
import { GruppeTierTodMeldenComponent } from '../gruppe-tier-tod-melden/gruppe-tier-tod-melden.component';
import { TierEditierenDialogComponent } from '../tier-editieren-dialog/tier-editieren-dialog.component';
import { TiereAlsCSVUploadDialogComponent } from '../tiere-als-csvupload-dialog/tiere-als-csvupload-dialog.component';
import { AbteilAendernDialogComponent } from './abteil-aendern-dialog/abteil-aendern-dialog.component';
import { DashboardEinstallenStepperDialogComponent } from '../gruppen-dashboard/dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.component';
import { DashboardEinstallenStepperDialogData } from '../gruppen-dashboard/dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.data';
import { HaendlerAendernDialogComponent } from './haendler-aendern-dialog/haendler-aendern-dialog.component';
import { HerkunftSetzenDialogComponent } from './herkunft-setzen-dialog/herkunft-setzen-dialog.component';
import { ReklamationenSetzenDialogComponent } from './reklamationen-setzen-dialog/reklamationen-setzen-dialog.component';
import { KontaktSetzenDialogComponent } from './kontakt-setzen-dialog/kontakt-setzen-dialog.component';
import { PreiseFestlegenDialogComponent } from '../preise-festlegen-dialog/preise-festlegen-dialog.component';
import { GewichteFestlegenDialogComponent } from '../gewichte-festlegen-dialog/gewichte-festlegen-dialog.component';

@Component({
    selector: 'kiene-gruppe-details',
    templateUrl: './gruppe-details.component.html',
    styleUrls: ['./gruppe-details.component.scss'],
})
export class GruppeDetailsComponent implements OnInit, OnDestroy {
    @ViewChild('menuTrigger') menu: MatMenuTrigger;

    @ViewChild('filterButton') filterButton: GruppeTierFilterButtonComponent;

    @ViewChild('tabGroup') tabGroup: MatTabGroup;

    gruppe: Gruppe;
    gruppeSubscription: Subscription;
    gruppeReloadSubscription: Subscription;
    watchClientSubscription: Subscription;

    tiere: GruppeTier[] = [];
    tableDescriptor = new TableDescriptor();

    verlaufIsLoading = true;

    gruppenVerlauf: GruppenVerlauf[];
    gruppenVerlaufSubscription: Subscription;
    gruppenVerlaufReloadSubscription: Subscription;
    gruppeAktualisierenSubscription: Subscription;

    gruppenStatistik: GruppenStatistik;
    gruppenStatistikSubscription: Subscription;

    schlachtungIconColumn: TableColumn;
    schlachtungGrenzeColumn: TableColumn;

    @ViewChild('kieneTable')
    kieneTable: KieneTableComponent;

    selectedRows: GruppeTier[] = [];
    filterSettings: TierFilterSettings = new TierFilterSettings();
    filterSaveEnabled = false;

    isSGS = true;
    selectedIndex = 0;
    search = '';
    rindermast = false;

    constructor(
        private readonly route: ActivatedRoute,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly dialog: MatDialog,
        private readonly fileDownloadService: FileDownloadService,
        private readonly pdfViewerService: PdfViewerDesktopService,
        private readonly messageService: MessageService,
        private readonly gruppeTierService: GruppeTierService,
        private readonly tableService: KieneTableService,
        private readonly gruppenService: GruppenService,
        private readonly ausstallenService: AusstallenService,
        private readonly localStorageService: LocalStorageService,
        private readonly appService: AppService,
        private readonly abgangService: GruppeAbgangService,
        private readonly einstallenService: EinstallenService,
    ) {
        const gruppeId = Number(this.route.snapshot.paramMap.get('id'));
        this.gruppe = new Gruppe();
        this.gruppe.gruppe_id = gruppeId;

        this.ladeDaten();
        this.initTierTable();
    }

    ngOnInit(): void {
        this.isSGS = this.localStorageService.isCurrentUserSgs();
        TierFilterSettingsPersistence.load(this.api).subscribe({
            next: state => {
                if (state?.saveFilterEnabled && state.settings?.isFilterActive()) {
                    this.setFilterSettings(state.settings);
                }
                this.filterSaveEnabled = state?.saveFilterEnabled ?? false;
            },
        });
        this.tableService.watchSearchTxt().subscribe({
            next: (search: string) => {
                this.search = search;
            },
        });

        this.gruppeReloadSubscription = this.gruppenService.watchReloadGruppe().subscribe({
            next: () => {
                this.loadGruppe();
                this.tableService.reload('watchReloadGruppe');
                this.loadGruppenStatistik();
            },
        });

        this.gruppenVerlaufReloadSubscription = this.gruppenService.watchReloadVerlauf().subscribe({
            next: () => {
                this.loadGruppenVerlauf();
            },
        });

        // Reagiere auf Gruppen-Aktualisierung nach Tierliste-Abschluss
        this.gruppeAktualisierenSubscription = this.abgangService.watchGruppeAktualisieren().subscribe({
            next: (gruppe_id: number) => {
                if (gruppe_id === this.gruppe.gruppe_id) {
                    this.loadGruppe();
                    this.loadGruppenVerlauf();
                    this.loadGruppenStatistik();
                    this.tableService.reload();
                }
            },
        });

        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe((response: Client) => {
            if (!response) {
                this.schlachtungGrenzeColumn.isActive = false;
                this.schlachtungIconColumn.isActive = false;
            } else {
                this.schlachtungGrenzeColumn.isActive = !response.schwein;
                this.schlachtungIconColumn.isActive = !response.schwein;
            }
            this.tableService.updateColumns();
        });
    }

    ladeDaten() {
        this.loadGruppe();
        this.loadGruppenVerlauf();
        this.loadGruppenStatistik();
        this.gruppenService.reloadStandorte();
    }

    ngOnDestroy() {
        this.gruppeSubscription?.unsubscribe();
        this.gruppenStatistikSubscription?.unsubscribe();
        this.gruppenVerlaufSubscription?.unsubscribe();
        this.gruppeReloadSubscription?.unsubscribe();
        this.gruppenVerlaufReloadSubscription?.unsubscribe();
        this.gruppeAktualisierenSubscription?.unsubscribe();
    }

    getGruppeTierColumns(): TableColumn[] {
        const columns = [];

        columns.push(new OhrmarkeTableColumn('ohrmarke_notnull', 'Ohrmarke'));
        columns.push(new TableColumn('transpondernummer', 'Transponder'));
        columns.push(new TableColumn('abteil', 'Abteil', null, null, null, null, ['abteil_string', 'abteil_number']));

        columns.push(new KieneBooleanTableColumn('ohrmarke_gescannt', 'Ohrmarke'));

        const conditionSettingsPass = [
            new ConditionSetting([new Condition('pdf_id_pass', Operator.EXISTIERT, undefined)], {
                icon: 'scanner',
                color: '#197E3E',
                tooltip: 'Pass eingescannt mit Scanner',
            }),
            new ConditionSetting([new Condition('pass_gescannt', Operator.GROESSER, 0)], {
                icon: 'barcode_reader',
                color: '#197E3E',
                tooltip: 'Pass gescannt mit Barcodeleser',
            }),
        ];
        columns.push(
            new ConditionTableColumn('pass_gescannt', 'Pass', conditionSettingsPass, {
                sortFields: ['ifnull(pass_gescannt,0)+ifnull(pdf_id_pass,0)'],
                defaultIcon: 'check_box_outline_blank',
                defaultColor: '#197E3E',
            }),
        );
        const conditionSettingsTierlisteImport = [
            new ConditionSetting([new Condition('tierliste_import', Operator.GROESSER, 0)], {
                icon: 'library_books',
                color: '#197E3E',
                tooltip: 'Aus Tierliste importiert',
            }),
        ];
        columns.push(
            new ConditionTableColumn('tierliste_import', 'Import', conditionSettingsTierlisteImport, {
                sortFields: ['tierliste_import'],
                defaultIcon: 'collections_bookmark',
                defaultColor: '#9e9e9e',
                defaultTooltip: '',
            }),
        );

        const conditionSettingsGeschlecht = [
            new ConditionSetting([new Condition('geschlecht_id', Operator.GLEICH, 1)], {
                icon: 'male',
                color: 'gray',
                tooltip: 'Männlich',
            }),
            new ConditionSetting([new Condition('geschlecht_id', Operator.GLEICH, 2)], {
                icon: 'female',
                color: 'gray',
                tooltip: 'Weiblich',
            }),
        ];
        columns.push(
            new ConditionTableColumn('geschlecht', 'Geschl.', conditionSettingsGeschlecht, {
                sortFields: ['geschlecht'],
            }),
        );
        columns.push(new TableColumn('bvd_status', 'BVD', null, null, 'bvd_text'));

        columns.push(new TableColumn('rasse_kuerzel', 'Rasse'));
        columns.push(new DateTableColumn('geburtsdatum', 'Geburtsdatum', 'dd.MM.yyyy'));
        columns.push(new DateTableColumn('einstalldatum_notnull', 'Einstalldatum', 'dd.MM.yyyy'));
        columns.push(new KieneBooleanTableColumn('tierliste_id', 'Liste'));
        columns.push(new TextTableColumn('kunde_zielbetrieb', 'Zielbetrieb'));
        columns.push(new TextTableColumn('kunde_zusatz_zielbetrieb', 'Zielbetrieb Zusatz'));
        columns.push(new DateTableColumn('abgangsdatum_notnull', 'Abgangsdatum', 'dd.MM.yyyy'));
        columns.push(new DateTableColumn('todesdatum_notnull', 'Todesdatum', 'dd.MM.yyyy'));
        columns.push(new NumberTableColumn('alter_tage', 'Alter', '1.0', 'd'));
        columns.push(new NumberTableColumn('tage_einstallung', 'Tage Einst.', '1.0', 'd'));
        const colorSettings = [
            new ConditionSetting([new Condition('schlachtgrenze_tage', Operator.GLEICH, null)], {
                color: '',
                icon: '',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 1)], {
                color: '#d50000',
                icon: 'restaurant',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 2)], {
                color: '#f2c52d',
                icon: 'restaurant',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 3)], {
                color: '#479864',
                icon: 'restaurant',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 4)], {
                color: '#8f8f8f',
                icon: 'restaurant',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 5)], {
                color: '#595050',
                icon: 'health_and_safety',
            }),
            new ConditionSetting([new Condition('grenze', Operator.GLEICH, 6)], { color: '#a10a0a', icon: 'no_meals' }),
        ];

        this.schlachtungIconColumn = new ConditionTableColumn('grenze', '', colorSettings, {
            defaultIcon: '',
            defaultColor: '#b6b2b2',
        });
        columns.push(this.schlachtungIconColumn);

        this.schlachtungGrenzeColumn = new DateTableColumn('schlachtgrenze', 'Schlachttermin ', 'dd.MM.yy');
        columns.push(this.schlachtungGrenzeColumn);
        columns.push(new NumberTableColumn('hit_schlachtgewicht', 'Schlachtgewicht', '1.2-2', 'kg'));

        const conditionSettingsZugang = [
            new ConditionSetting([new Condition('status_id_einstallen', Operator.GLEICH, 143)], {
                icon: 'error',
                color: '#bc4b51',
                tooltipFieldnames: ['hit_fehler_einstallen'],
            }),
            new ConditionSetting([new Condition('status_id_einstallen', Operator.IN, [141, 144])], {
                icon: 'check_circle',
                color: '#f2c52d',
                tooltip: 'Zugang wird an HI-Tier gemeldet!',
            }),
            new ConditionSetting([new Condition('status_id_einstallen', Operator.IN, [142])], {
                icon: 'check_circle',
                color: '#8cb369',
                tooltip: 'Zugangsmeldung erfolgreich an HI-Tier gesendet!',
            }),
            new ConditionSetting([new Condition('status_id_einstallen', Operator.IN, [145])], {
                icon: 'check_circle_outline',
                color: '#8cb369',
                tooltip: 'Zugangsmeldung aus HI-Tier gelesen!',
            }),
        ];

        columns.push(
            new ConditionTableColumn('status_id_einstallen', 'HIT Zugang', conditionSettingsZugang, {
                sortFields: ['status_id_einstallen'],
                defaultIcon: 'block',
                defaultColor: 'gray',
                defaultTooltip: 'Zugang nicht an HI-Tier melden!',
            }),
        );

        const conditionSettingsAbgang = [
            new ConditionSetting([new Condition('status_id_abgang', Operator.GLEICH, 143)], {
                icon: 'error',
                color: '#bc4b51',
                tooltipFieldnames: ['hit_fehler_abgang'],
            }),
            new ConditionSetting([new Condition('status_id_abgang', Operator.IN, [141, 144])], {
                icon: 'check_circle',
                color: '#f2c52d',
                tooltip: 'Abgang wird an HI-Tier gemeldet!',
            }),
            new ConditionSetting([new Condition('status_id_abgang', Operator.IN, [142])], {
                icon: 'check_circle',
                color: '#8cb369',
                tooltip: 'Abgangsmeldung erfolgreich an HI-Tier gesendet!',
            }),
            new ConditionSetting([new Condition('status_id_abgang', Operator.IN, [145])], {
                icon: 'check_circle_outline',
                color: '#8cb369',
                tooltip: 'Abgangsmeldung aus HI-Tier gelesen!',
            }),
        ];
        const conditionSettingsTod = [
            new ConditionSetting([new Condition('status_id_tod', Operator.GLEICH, 143)], {
                icon: 'error',
                color: '#bc4b51',
                tooltipFieldnames: ['hit_fehler_tod'],
            }),
            new ConditionSetting([new Condition('status_id_tod', Operator.IN, [141, 144])], {
                icon: 'check_circle',
                color: '#f2c52d',
                tooltip: 'Tod wird an HI-Tier gemeldet!',
            }),
            new ConditionSetting([new Condition('status_id_tod', Operator.IN, [142])], {
                icon: 'check_circle',
                color: '#8cb369',
                tooltip: 'Todmeldung erfolgreich an HI-Tier gesendet!',
            }),
            new ConditionSetting([new Condition('status_id_tod', Operator.IN, [145])], {
                icon: 'check_circle_outline',
                color: '#8cb369',
                tooltip: 'Todmeldung aus HI-Tier gelesen!',
            }),
        ];
        columns.push(
            new ConditionTableColumn('status_id_abgang', 'HIT Abgang', conditionSettingsAbgang, {
                sortFields: ['status_id_abgang'],
                defaultIcon: 'block',
                defaultColor: 'gray',
                defaultTooltip: 'Abgang nicht an HI-Tier melden!',
            }),
        );
        columns.push(
            new ConditionTableColumn('status_id_tod', 'HIT Tod', conditionSettingsTod, {
                sortFields: ['status_id_tod'],
                defaultIcon: 'block',
                defaultColor: 'gray',
                defaultTooltip: 'Tod nicht an HI-Tier melden!',
            }),
        );
        columns.push(new KieneBooleanTableColumn('hit_sync', 'HIT Sync', { tooltip: 'Tier wird synchronisert' }));

        columns.push(new DateTableColumn('wartezeit_fleisch_bis', 'Wartezeit-Fleisch', 'dd.MM.yy'));

        const conditionSettingsSgs = [
            new ConditionSetting([new Condition('sgs_id_zertifizierung', Operator.EXISTIERT, undefined)], {
                icon: 'verified',
                color: '#8cb369',
                tooltip: 'SGS Zertifizierungsdatei wurde erstellt.',
            }),
        ];

        columns.push(
            new ConditionTableColumn('sgs_id_zertifizierung', 'SGS Zert.', conditionSettingsSgs, {
                sortFields: ['sgs_id_zertifizierung'],
                defaultIcon: '',
                defaultColor: 'gray',
                defaultTooltip: 'Noch keine SGS Zertifizierungsdatei erstellt.',
            }),
        );

        // Preise-Spalten nur anzeigen wenn Permission 11015 vorhanden ist
        if (this.localStorageService.hasPermission(11015)) {
            columns.push(new NumberTableColumn('ek_brutto', 'EK Brutto', '1.2-2', null));
        }

        let reklamationTableColumn = new ArrayTableColumn('reklamationen', 'Reklamationen', ['reklamation']);
        reklamationTableColumn.isSortable = false;
        columns.push(reklamationTableColumn);

        // Händler-Spalte: Zeige neuen Betriebskontakt-Händler wenn vorhanden, sonst alten Viehhaendler
        columns.push(new TableColumn('betriebskontakt_haendler', 'Händler'));
        columns.push(new TableColumn('vvvo_betriebskontakt_haendler', 'VVVO Händler'));
        // Außendienst-Spalte nur anzeigen wenn Permission 11017 vorhanden ist (nur zum Anzeigen)
        if (this.localStorageService.hasPermission(11017)) {
            columns.push(new TableColumn('aussendienst', 'Außendienst'));
        }
        columns.push(new TableColumn('herkunft_betrieb', 'Herkunfts betrieb'));
        columns.push(new TableColumn('herkunft_vvvo', 'VVVO Herkunftsbetrieb'));

        let bemerkungTableColumn = new ArrayTableColumn('bemerkungen', 'Bemerkungen', ['bemerkung']);
        bemerkungTableColumn.isSortable = false;
        columns.push(bemerkungTableColumn);
        columns.push(new NumberTableColumn('einstallgewicht', 'Einstallgewicht', '1.2-2', 'kg'));
        columns.push(new NumberTableColumn('ausstallgewicht', 'Ausstallgewicht', '1.2-2', 'kg'));

        return columns;
    }

    getToolbarButtons(): ToolbarButton[] {
        const buttons: ToolbarButton[] = [];

        return buttons;
    }

    getSelectionToolbarButtons(): SelectionToolbarButton[] {
        return [];
    }

    loadGruppe() {
        this.gruppeSubscription?.unsubscribe();
        this.gruppeSubscription = this.api
            .getByIdAlternative(
                this.apiBaseUrl + 'gruppe/read_one_kundenportal.php',
                'gruppe_id',
                this.gruppe?.gruppe_id,
            )
            .subscribe({
                next: (gruppe: Gruppe) => {
                    this.gruppe = gruppe;
                    this.rindermast =
                        this.gruppe.produktionsabschnitt_id === 68 || this.gruppe.produktionsabschnitt_id === 69;
                },
                error: err => {
                    this.messageService.errorMessage('Gruppe konnte nicht geladen werden!', err);
                },
            });
    }

    initTierTable() {
        this.tableDescriptor.headline = 'Tiere';
        this.tableDescriptor.uniqueIdentifier = 'Gruppen-Gruppen-Tiere';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'gruppe_tier/read_kundenportal.php';
        this.tableDescriptor.initialSortColumn = 'right(ohrmarke_notnull,5)';
        this.tableDescriptor.nameOfIdField = 'gt_id';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openGruppeTierDialog.bind(this);
        this.tableDescriptor.selectable = true;
        this.tableDescriptor.showDownloads = true;
        this.tableDescriptor.showRefresh = true;
        this.tableDescriptor.expandable = false;
        this.tableDescriptor.clientSideSearch = true;
        this.tableDescriptor.clearSearch = true;
        this.tableDescriptor.stickyHeader = true;

        this.tableDescriptor.params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id?.toString());

        this.tableDescriptor.permissionView = 9121;
        this.tableDescriptor.permissionCreate = 9122;

        this.tableDescriptor.columns = this.getGruppeTierColumns();
        this.tableDescriptor.toolbarButtons = this.getToolbarButtons();
        this.tableDescriptor.selectionToolbarButtons = this.getSelectionToolbarButtons();
        this.tableDescriptor.options = this.getOptions();
    }

    getOptions(): TableOption[] {
        const options = [];
        options.push(
            new TableOption(this.openAddGruppeTierReklamation.bind(this), 'Reklamation editieren', 'comment', 9122),
        );
        options.push(new TableOption(this.openBemerkungDialog.bind(this), 'Bemerkungen', 'chat', 9192));
        options.push(new TableOption(this.openEditierenDialog.bind(this), 'Bearbeiten', 'edit', 9122));
        options.push(new TableOption(this.deleteGruppeTier.bind(this), 'Löschen', 'delete', 9124));
        options.push(
            new TableOption(this.openTodMeldenDialog.bind(this), 'Tod melden', 'event_busy', 9125, {
                conditions: [new Condition('kp_todesdatum', Operator.EXISTIERT_NICHT, null)],
            }),
        );

        options.push(
            new TableOption(
                this.openEinzelneEinstalldatumAendernDialog.bind(this),
                'Einstalldatum ändern',
                'today',
                9128,
            ),
        );
        options.push(
            new TableOption(
                this.openEinzelneAbgangsdatumAendernDialog.bind(this),
                'Abgangsdatum ändern',
                'event',
                9129,
                { conditions: [new Condition('hit_abgangsdatum', Operator.EXISTIERT, undefined)] },
            ),
        );
        options.push(
            new TableOption(this.openAbgangStornierenDialog.bind(this), 'Abgang stornieren', 'cancel', 9129, {
                conditions: [new Condition('hit_abgangsdatum', Operator.EXISTIERT, undefined)],
            }),
        );
        options.push(
            new TableOption(this.openPassVorhandenManuellDialog.bind(this), 'Pass vorhanden', 'badge', 9122, {
                conditions: [new Condition('pass_gescannt', Operator.GLEICH, 0)],
            }),
        );
        options.push(
            new TableOption(this.openOhrmarkeVorhandenManuellDialog.bind(this), 'Ohrmarke vorhanden', 'label', 9122, {
                conditions: [new Condition('ohrmarke_gescannt', Operator.GLEICH, 0)],
            }),
        );
        options.push(
            new TableOption(this.gruppeAendernTier.bind(this), 'Gruppe ändern', 'sync_alt', 9122, {
                conditions: [new Condition('tierliste_id', Operator.EXISTIERT_NICHT, undefined)],
            }),
        );
        return options;
    }

    openOhrmarkeVorhandenManuellDialog(gt: GruppeTier) {
        this.gruppeTierService.ohrmarkeAlsGescanntMarkieren(gt.gruppe_id, [gt]).subscribe({
            next: (result: boolean) => {
                if (result === true) {
                    this.tableService.reload();
                }
            },
        });
    }

    openPassVorhandenManuellDialog(gt: GruppeTier) {
        const confirmInput = new ConfirmDialogInput();
        confirmInput.text = 'Wollen Sie wirklich den Pass für das Tier manuell als vorhanden eintragen?';
        confirmInput.headline = 'Pass als vorhanden nachtragen';
        confirmInput.okButton = 'Bestätigen';
        confirmInput.buttonColor = 'accent';
        confirmInput.showCancel = true;
        confirmInput.cancelButton = 'Abbrechen';

        this.dialog
            .open(ConfirmDialogComponent, { data: confirmInput })
            .afterClosed()
            .subscribe((resp: ConfirmDialogResult) => {
                if (resp?.confirmed) {
                    gt.pass_gescannt_manuell = 1;
                    this.updateTier(gt);
                }
            });
    }

    updateTier(tier: GruppeTier) {
        this.gruppeTierService.update(tier).subscribe({
            next: () => {
                this.tableService.reload();
                this.messageService.infoMessage('Tier erfolgreich aktualisiert.');
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Aktualisieren des Tiers!', err);
            },
        });
    }

    openEinzelneEinstalldatumAendernDialog(gruppeTier: GruppeTier) {
        this.openMehrereEinstalldatumAendernDialog([gruppeTier]);
    }

    openMehrereEinstalldatumAendernDialog(gruppenTiere: GruppeTier[]) {
        const input = new EnterValueInput();
        input.title = 'Einstalldatum ändern';
        input.text =
            'Es wird das Einstalldatum für ' +
            gruppenTiere.length +
            ' Tier(e) geändert. Die HIT Zugangsmeldung wird ebenfalls aktualisiert.';
        input.okButton = 'Einstalldatum ändern';
        input.buttonColor = 'accent';
        input.buttonsToCorners = true;
        input.addInputValue('Neues Einstalldatum', 'date');

        this.dialog
            .open(EnterValueDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: EnterValueResponse) => {
                    if (result?.result && result?.getValue(0)) {
                        const einstalldatumNeu: Date = result.getValue(0);

                        this.gruppeTierService.einstalldatumHitAendern(gruppenTiere, einstalldatumNeu).subscribe({
                            next: () => {
                                this.messageService.infoMessage(
                                    'Das Einstalldatum wurde erfolgreich geändert! Die Aktualisierung in der HIT Datenbank kann bis zu fünf Minuten dauern.',
                                );
                                this.tableService.reload('openEinstalldatumAendernDialog');
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Ändern des Einstalldatums!', err);
                                this.tableService.reload('openEinstalldatumAendernDialog ERROR');
                            },
                        });
                    }
                },
            });
    }

    openGruppeEinstallenDialog(): void {
        const gruppeId = Number(this.gruppe?.gruppe_id || 0);
        if (gruppeId <= 0) {
            return;
        }

        this.einstallenService.clearLastScanErgebnisse();
        this.einstallenService.clearPendingGewichte();
        this.einstallenService.clearCurrentEinstalldatum();
        this.einstallenService.clearCurrentEinstallTierlisteId();

        const stepperData: DashboardEinstallenStepperDialogData = {
            continueDirectScan: {
                gruppeId,
                kundeId: this.gruppe?.kunde_id ?? null,
                initialStep: 'einstallen',
            },
        };

        this.dialog
            .open(DashboardEinstallenStepperDialogComponent, {
                width: '1100px',
                maxWidth: '96vw',
                maxHeight: '92vh',
                panelClass: 'dashboard-einstallen-stepper-dialog-panel',
                autoFocus: false,
                restoreFocus: false,
                data: stepperData,
            })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.einstallenService.clearCurrentEinstallTierlisteId();
                    this.einstallenService.clearLastScanErgebnisse();
                    this.einstallenService.clearPendingGewichte();
                    this.einstallenService.clearCurrentEinstalldatum();
                    this.tableService.reload('openGruppeEinstallenDialog:close');
                },
            });
    }

    openEinzelneAbgangsdatumAendernDialog(gruppeTier: GruppeTier) {
        this.openMehrereAbgangsdatumAendernDialog([gruppeTier]);
    }

    openMehrereAbgangsdatumAendernDialog(gruppeTiere: GruppeTier[]) {
        const input = new EnterValueInput();
        input.title = 'Abgangsdatum ändern';
        input.text =
            'Es wird das Abgangsdatum für ' +
            gruppeTiere.length +
            ' Tier(e) geändert. Die HIT Abgangsmeldung wird ebenfalls aktualisiert.';
        input.okButton = 'Abgangsdatum ändern';
        input.buttonColor = 'accent';
        input.buttonsToCorners = true;
        input.addInputValue('Neues Abgangsdatum', 'date');

        const dialogRef = this.dialog.open(EnterValueDialogComponent, { data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: EnterValueResponse) => {
                if (result?.result && result?.getValue(0)) {
                    const abgangsdatumNeu: Date = result.getValue(0);
                    this.gruppeTierService.abgangsdatumHitAendern(gruppeTiere, abgangsdatumNeu).subscribe({
                        next: () => {
                            this.messageService.infoMessage(
                                'Das Abgangsdatum wurde erfolgreich geändernt! Die Aktualisierung in der HIT Datenbank kann bis zu fünf Minuten dauern.',
                            );
                            this.tableService.reload('openAbgangsdatumAendernDialog');
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                            this.tableService.reload('openAbgangsdatumAendernDialog ERROR');
                        },
                    });
                }
            },
        });
    }

    uploadTiereCSV() {
        const dialogRef = this.dialog.open(TiereAlsCSVUploadDialogComponent, {
            minWidth: '1000px',
            data: { gruppe: this.gruppe },
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.messageService.infoMessage('Die CSV Datei wurde erfolgreich hochgeladen!');
                    this.loadGruppe(); // für Details
                    this.tableService.reload('uploadTiereCSV');
                }
            },
        });
    }

    openEditierenDialog(tier: GruppeTier) {
        const dialogRef = this.dialog.open(TierEditierenDialogComponent, { width: '25vw', data: { tier: tier } });

        dialogRef.afterClosed().subscribe({
            next: () => {
                this.tableService.reload('openEditierenDialog');
            },
        });
    }

    deleteGruppeTier(tier: GruppeTier) {
        const input = new ConfirmDialogInput();
        input.headline = 'Tier ' + tier.ohrmarke_notnull + ' löschen?';
        input.text =
            'Wollen Sie dieses Tier wirklich löschen? Eine mögliche HIT Zugangsmeldung über vetvet wird ebenfalls storniert!';
        input.okButton = 'Löschen';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });
        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.gruppeTierService.deleteTier(tier).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Die Ohrmarke wurde erfolgreich gelöscht!');
                            this.tableService.reload('deleteGruppeTier');
                        },
                        error: err => {
                            this.messageService.errorMessage('Tier konnte nicht gelöscht werden!', err);
                        },
                    });
                }
            },
        });
    }

    openAddGruppeTierReklamation(value: GruppeTier) {
        const dialogRef = this.dialog.open(AddGruppeTierReklamationDialogComponent, { data: { gruppeTier: value } });
        dialogRef.afterClosed().subscribe({
            next: (gruppeTier: GruppeTier) => {
                if (gruppeTier) {
                    const reklamationIds =
                        gruppeTier?.reklamationen?.map(r => Number(r?.tierreklamation_id)).filter(id => id > 0) ?? [];
                    this.gruppeTierService
                        .updateReklamationenMultiple([gruppeTier], reklamationIds, this.gruppe?.gruppe_id)
                        .subscribe({
                        next: success => {
                            if (success) {
                                this.tableService.reload('openAddGruppeTierReklamation');
                                this.messageService.infoMessage('Reklamationen wurden erfolgreich aktualisiert!');
                            }
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
        });
    }

    downloadGruppeCsv() {
        this.fileDownloadService.downloadCSV('gruppe_tier/read_csv.php', this.getGruppeDownloadParams());
    }

    downloadGruppePdf() {
        let params = this.getGruppeDownloadParams();
        for (const label of this.filterSettings?.getFilterLabels() || []) {
            params = params.append('filter_label[]', label);
        }
        this.pdfViewerService.openPdfViewer(
            new PdfViewerDialogInput('gruppe_tier/read_pdf.php', params, 'Tiere dieser Gruppe', {
                email: { sende_mail: true, kunde_id: this.gruppe?.kunde_id },
            }),
        );
    }

    downloadGruppeExcel() {
        this.fileDownloadService.downloadExcel('gruppe_tier/read_excel.php', this.getGruppeDownloadParams());
    }

    private getGruppeDownloadParams(): HttpParams {
        let params = this.filterSettings?.getAsParams() || new HttpParams();
        return params.set('gruppe_id', this.gruppe.gruppe_id.toString());
    }

    downloadReklamationsPdf() {
        const dialogRef = this.dialog.open(GruppeReklamationPdfHaendlerAuswahlDialogComponent, {
            minWidth: '50vw',
            data: this.gruppe,
        });
        dialogRef.afterClosed().subscribe((res: GruppeReklamationPdfHaendlerAuswahlDialogOutput) => {
            if (res) {
                const empfaenger = [];
                if (res.empfaenger) {
                    empfaenger.push(res.empfaenger);
                }
                this.pdfViewerService.openPdfViewer(
                    new PdfViewerDialogInput(
                        'gruppe/read_reklamationspdf_kundenportal.php',
                        res.params.set('gruppe_id', this.gruppe.gruppe_id.toString()),
                        `Reklamation ${this.gruppe.bezeichnung}`,
                        { email: { sende_mail: true, kunde_id: this.gruppe.kunde_id }, empfaenger: empfaenger },
                    ),
                );
            }
        });
    }

    openAbgangslisteDownloadDialog() {
        this.dialog
            .open(GruppeAbgangDownloadDialogComponent, { width: '50vw', data: { gruppe: this.gruppe } })
            .afterClosed()
            .subscribe((res: AbgangDownloadRequestPojo) => {
                if (res?.confirmed === true) {
                    if (res?.pdfDownloadVerfuegbar()) {
                        // eine Pdf
                        this.downloadAbgaengePdf(res);
                    } else if (res?.csvDownloadVerfuegbar()) {
                        // eine CSV
                        this.fileDownloadService.downloadCSV(
                            'tierliste/read_csv_kundenportal.php',
                            res.getHttpParams(),
                        );
                    } else if (res?.excelDownloadVerfuegbar()) {
                        // eine Excel
                        this.fileDownloadService.downloadExcel(
                            'tierliste/read_excel_kundenportal.php',
                            res.getHttpParams(),
                        );
                    } else {
                        this.fileDownloadService.downloadZip(
                            'tierliste/read_zip_kundenportal.php',
                            res.getHttpParams(),
                        );
                    }
                }
            });
    }

    downloadAbgaengePdf(res: AbgangDownloadRequestPojo) {
        this.pdfViewerService.openPdfViewer(
            new PdfViewerDialogInput('tierliste/read_pdf_kundenportal.php', res.getHttpParams(), 'Ausstallliste', {
                email: { sende_mail: true, kunde_id: null },
            }),
        );
    }

    /**
     * s1 - s2 ==> (+/- {result})
     * @param s1
     * @param s2
     * @param options - asPercentage: boolean
     */
    getDifferenceString(s1: number | undefined, s2: number | undefined, options?: { asPercentage: boolean }): string {
        if (s1 && s2) {
            let erg: number;
            if (options?.asPercentage) {
                erg = Number(((s1 / s2) * 100).toFixed(1));
            } else {
                erg = s1 - s2;
            }
            if (erg > 0) {
                return `(${options?.asPercentage ? '' : '+'}${erg.toString()}${options?.asPercentage ? '%' : ''})`;
            } else if (erg < 0) {
                return `(${erg.toString()}${options?.asPercentage ? '%' : ''})`;
            } else {
                return '';
            }
        }
        return '';
    }

    openGruppeInformationenDialog() {
        this.dialog
            .open(GruppeInformationenDialogComponent, { width: '50vw', data: { gruppe_id: this.gruppe.gruppe_id } })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.loadGruppe();
                },
            });
    }

    loadGruppenVerlauf() {
        this.verlaufIsLoading = true;
        this.gruppenVerlaufSubscription?.unsubscribe();
        this.gruppenVerlaufSubscription = this.gruppenService.ladeGruppenVerlauf(this.gruppe?.gruppe_id).subscribe({
            next: response => {
                this.verlaufIsLoading = false;
                this.gruppenVerlauf = response.records;
            },
            error: err => {
                this.verlaufIsLoading = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    isEinstalldatumAendernDisabled() {
        const selectedRows = this.tableService.getSelectedRows();
        return selectedRows?.length === 0 || selectedRows.some((row: GruppeTier) => row.kp_abgangsdatum === null);
    }

    isAusstalldatumAenderDisabled() {
        const selectedRows = this.tableService.getSelectedRows();
        return selectedRows?.length === 0;
    }

    zugaengeMelden() {
        this.einstallenService.clearCurrentEinstallTierlisteId();
        this.einstallenService.clearLastScanErgebnisse();
        this.einstallenService.clearPendingGewichte();

        const input = new EinstallenMeldenDialogInput();
        input.gruppe_id = this.gruppe?.gruppe_id;
        input.gs_id = this.gruppe?.gs_id;
        input.wholeGroup = true;

        this.dialog
            .open(EinstallenMeldenDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: EinstallenMeldenDialogResult) => {
                    if (result?.ok) {
                        this.tableService.reload();
                    }
                },
            });
    }

    tiereAusHitNachladen(): void {
        this.messageService.infoMessage('Tiere werden aus HIT geladen!');
        this.gruppenService.tiereAusHitNachladen(this.gruppe).subscribe({
            next: () => {
                this.messageService.infoMessage('Tiere erfolgreich aus HIT geladen!');
                this.tableService.reload('tiereAusHitNachladen');
            },
            error: error => {
                this.messageService.errorMessage('Tiere konnten nicht aus HIT nachgeladen werden!', error);
            },
        });
    }

    abgaengeMelden() {
        const inp = new ConfirmDialogInput();
        inp.text =
            'Sollen alle Tiere bei HI-Tier abgemeldet werden, die sich in einer abgeschlossenen Tierliste befinden?';
        inp.okButton = 'Melden';
        inp.headline = 'Abgänge melden';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: inp });

        dialogRef.afterClosed().subscribe((resp: ConfirmDialogResult) => {
            if (resp?.confirmed) {
                this.api.updateGeneric(this.apiBaseUrl + 'gruppe_tier/abgaenge_hit.php', this.gruppe).subscribe({
                    next: () => {
                        this.messageService.infoMessage('Tiere werden bei HIT abgemeldet!');
                        this.tableService.reload();
                    },
                    error: err => {
                        this.messageService.errorMessage('Tiere können nicht abgemeldet werden!', err);
                    },
                });
            }
        });
    }

    loadGruppenStatistik() {
        const params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id.toString());

        this.gruppenStatistikSubscription?.unsubscribe();
        this.gruppenStatistikSubscription = this.api
            .get(this.apiBaseUrl + 'gruppe_tier/read_statistik.php', params)
            .subscribe({
                next: gruppenStatistik => {
                    this.gruppenStatistik = gruppenStatistik;
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    gibAnzahlStatistiken() {
        const l1 = this.gruppenStatistik?.geschlechter?.length;
        const l2 = this.gruppenStatistik?.reklamationen?.length;
        const l3 = this.gruppenStatistik?.rassen?.length;
        const l4 = this.gruppenStatistik?.abteile?.length;
        return (l1 ? l1 : 0) + (l2 ? l2 : 0) + (l3 ? l3 : 0) + (l4 ? l4 : 0);
    }

    setFilterSettings(filterSettings: TierFilterSettings) {
        this.filterSettings = filterSettings;
        this.tableDescriptor.filterParams = this.filterSettings?.getAsParams();
        this.tableService.reload('setFilterSettings');
    }

    statistikOpenable() {
        return (
            this.gruppenStatistik &&
            (this.gruppenStatistik?.rassen.length > 0 ||
                this.gruppenStatistik?.geschlechter.length > 0 ||
                this.gruppenStatistik?.abteile.length > 0 ||
                this.gruppenStatistik?.reklamationen.length > 0)
        );
    }

    verlaufOpenable() {
        return this.gruppenVerlauf && this.gruppenVerlauf?.length > 0;
    }

    eingescanntePaesseVerwalten() {
        this.dialog
            .open(GruppeTierPassScanVerwaltungDialogComponent, { minWidth: '50vw', data: this.gruppe })
            .afterClosed()
            .subscribe({
                next: (tiereUpdated: boolean) => {
                    if (tiereUpdated) {
                        this.tableService.reload('eingescanntePaesseVerwalten');
                        this.loadGruppe();
                        this.loadGruppenStatistik();
                    }
                },
            });
    }

    zertifikateAnSgsEinzeln(gruppenTiere: GruppeTier[]) {
        this.gruppenService.zertifikateAnSGS({ einzelneTiere: { gruppenTiere: gruppenTiere } });
    }

    zertifikateAnSGS() {
        this.gruppenService.zertifikateAnSGS({ ganzeGruppe: { gruppe_id: this.gruppe?.gruppe_id } });
    }

    ausstallen() {
        const selectedRows = this.tableService.getSelectedRows() || [];
        if (selectedRows.length === 0) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }
        this.ausstallenService.ausstallen(this.gruppe, true, selectedRows);
    }

    public alleOhrmarkenGescannt() {
        this.gruppeTierService
            .ohrmarkeAlsGescanntMarkieren(this.gruppe?.gruppe_id, this.tableService.getSelectedRows())
            .subscribe({
                next: (b: boolean) => {
                    if (b) {
                        this.tableService.reload('alleOhrmarkenGescannt');
                    }
                },
            });
    }

    canUseStandortwechsel(): boolean {
        return this.localStorageService.hasPermission(9352);
    }

    standortwechsel() {
        // Standortwechsel is now whole-group only.
        this.loadAlleTiereFuerStandortwechsel();
    }

    private loadAlleTiereFuerStandortwechsel(): void {
        const pageSize = 1000;
        const allRows: { gt_id: number; ohrmarke_notnull: string }[] = [];

        const loadPage = (offset: number) => {
            let params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id?.toString());
            params = params.set('limit', pageSize.toString());
            params = params.set('offset', offset.toString());
            params = params.set('standort_wechsel_aktiv', '1');

            this.api.get(this.apiBaseUrl + 'gruppe_tier/read_kundenportal.php', params).subscribe({
                next: response => {
                    const rows = response?.records || [];
                    for (const t of rows) {
                        const gtId = Number(t?.gt_id);
                        if (
                            gtId > 0 &&
                            GruppeStandortWechselnDialogComponent.isTierAktivForStandortwechsel(t)
                        ) {
                            allRows.push({
                                gt_id: gtId,
                                ohrmarke_notnull: t?.ohrmarke_notnull,
                            });
                        }
                    }

                    const totalCount = Number(response?.count);
                    const loadedCount = allRows.length;
                    if (!isNaN(totalCount) && loadedCount < totalCount && rows.length > 0) {
                        loadPage(offset + pageSize);
                        return;
                    }

                    this.openStandortwechselDialog(allRows);
                },
                error: err => {
                    this.messageService.errorMessage('Tiere fuer Standortwechsel konnten nicht geladen werden!', err);
                    this.openStandortwechselDialog([]);
                },
            });
        };

        loadPage(0);
    }

    private openStandortwechselDialog(selectedTiere: { gt_id: number; ohrmarke_notnull: string }[]) {
        const dialogRefStandortWechsel = this.dialog.open(GruppeStandortWechselnDialogComponent, {
            data: { gruppe: this.gruppe, selectedTiere: selectedTiere },
        });
        dialogRefStandortWechsel.afterClosed().subscribe({
            next: (result: GruppeStandortWechselnDialogResult) => {
                if (result && result.confirm) {
                    this.loadGruppe();
                    this.loadGruppenVerlauf();
                    this.gruppenService.reloadStandorte();
                }
            },
        });
    }

    tabChanged(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;
    }

    public tabWechseln(index: number) {
        this.selectedIndex = index;
    }

    public abteilAendern(): void {
        const input: GruppeTier[] = <GruppeTier[]>this.tableService.getSelectedRows();
        this.dialog
            .open(AbteilAendernDialogComponent, { data: input, width: '400px' })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.tableService.reload('GruppeTier: abteilAendern');
                },
            });
    }

    public haendlerAendern(): void {
        const input: GruppeTier[] = <GruppeTier[]>this.tableService.getSelectedRows();
        this.dialog
            .open(HaendlerAendernDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: { confirm?: boolean } | boolean | undefined) => {
                    const changed = result === true || (typeof result === 'object' && !!result?.confirm);
                    if (!changed) {
                        return;
                    }
                    this.messageService.infoMessage('Händler wurde für selektierte Tiere geändert.');
                    this.tableService.reload('GruppeTier: haendlerAendern');
                },
            });
    }

    public openKontaktSetzenDialog(): void {
        if (!this.localStorageService.hasPermission(11014)) {
            this.messageService.errorMessage('Sie haben keine Berechtigung für diese Aktion.', null);
            return;
        }

        const selectedTiere: GruppeTier[] = <GruppeTier[]>this.kieneTable.getSelectedRows();
        if (!selectedTiere?.length) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }

        this.dialog
            .open(KontaktSetzenDialogComponent, {
                width: '700px',
                maxWidth: '95vw',
                data: { tiere: selectedTiere },
            })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result) {
                        this.tableService.reload('GruppeTier: kontaktSetzen');
                    }
                },
            });
    }

    public openHerkunftSetzenDialog(): void {
        if (!this.localStorageService.hasPermission(11014)) {
            this.messageService.errorMessage('Sie haben keine Berechtigung für diese Aktion.', null);
            return;
        }

        const selectedTiere: GruppeTier[] = <GruppeTier[]>this.kieneTable.getSelectedRows();
        if (!selectedTiere?.length) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }

        this.dialog
            .open(HerkunftSetzenDialogComponent, {
                width: '720px',
                maxWidth: '95vw',
                data: { tiere: selectedTiere },
            })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result) {
                        this.tableService.reload('GruppeTier: herkunftSetzen');
                    }
                },
            });
    }

    public openReklamationenSetzenDialog(): void {
        if (!this.localStorageService.hasPermission(9129)) {
            this.messageService.errorMessage('Sie haben keine Berechtigung für diese Aktion.', null);
            return;
        }

        const selectedTiere: GruppeTier[] = <GruppeTier[]>this.kieneTable.getSelectedRows();
        if (!selectedTiere?.length) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }

        this.dialog
            .open(ReklamationenSetzenDialogComponent, {
                width: '600px',
                maxWidth: '95vw',
                data: { tiere: selectedTiere },
            })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result) {
                        this.tableService.reload('GruppeTier: reklamationenSetzen');
                    }
                },
            });
    }

    public addCommentToSelected(): void {
        this.selectedRows = this.tableService.getSelectedRows();

        this.dialog
            .open(TexteingabeDialogComponent)
            .afterClosed()
            .subscribe({
                next: (result: TexteingabeResult) => {
                    if (result?.confirmed && result.text) {
                        const gtm = new GruppeTierBemerkung();
                        this.selectedRows.forEach((row: GruppeTier) => {
                            gtm.gt_ids.push(row.gt_id);
                        });
                        gtm.bemerkung = result.text;

                        this.api
                            .post(
                                this.apiBaseUrl + 'gruppe_tier_bemerkung/update_kundenportal_bemerkungen.php',
                                gtm,
                                undefined,
                            )
                            .subscribe({
                                next: () => {
                                    this.tableService.reload();
                                    this.messageService.infoMessage('Bemerkung wurde hinzugefügt!');
                                },
                                error: err => {
                                    this.messageService.errorMessage('Fehler!', err);
                                },
                            });
                    }
                },
            });
    }

    public openPreiseFestlegenDialog(): void {
        if (!this.localStorageService.hasPermission(11015)) {
            this.messageService.errorMessage('Sie haben keine Berechtigung für diese Aktion.', null);
            return;
        }

        this.selectedRows = this.kieneTable.getSelectedRows();

        if (this.selectedRows.length === 0) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }

        const dialogRef = this.dialog.open(PreiseFestlegenDialogComponent, {
            width: '500px',
            data: { gruppeTiere: this.selectedRows },
        });

        dialogRef.afterClosed().subscribe({
            next: (result: boolean) => {
                if (result === true) {
                    this.tableService.reload();
                }
            },
        });
    }

    public openGewichteFestlegenDialog(): void {
        this.selectedRows = this.kieneTable.getSelectedRows();

        if (this.selectedRows.length === 0) {
            this.messageService.errorMessage('Bitte waehlen Sie mindestens ein Tier aus.', null);
            return;
        }

        const dialogRef = this.dialog.open(GewichteFestlegenDialogComponent, {
            width: '500px',
            data: { gruppeId: this.gruppe?.gruppe_id, gruppeTiere: this.selectedRows },
        });

        dialogRef.afterClosed().subscribe({
            next: (result: boolean) => {
                if (result === true) {
                    this.tableService.reload('GruppeTier: gewichteFestlegen');
                }
            },
        });
    }

    public canChangeGewichte(): boolean {
        return this.localStorageService.hasPermission(9161);
    }

    public openAussendienstSetzenDialog(): void {
        if (!this.localStorageService.hasPermission(11016)) {
            this.messageService.errorMessage('Sie haben keine Berechtigung für diese Aktion.', null);
            return;
        }

        this.selectedRows = this.kieneTable.getSelectedRows();

        if (this.selectedRows.length === 0) {
            this.messageService.errorMessage('Bitte wählen Sie mindestens ein Tier aus.', null);
            return;
        }

        this.gruppeTierService.aussendienstSetzen(this.selectedRows).subscribe({
            next: (result: boolean) => {
                if (result === true) {
                    this.tableService.reload();
                }
            },
        });
    }

    getIcon(bewegung_typ: string) {
        switch (bewegung_typ) {
            case 'login':
                return 'arrow_circle_right';
            case 'logout':
                return 'arrow_circle_left';
            case 'local_hospital':
                return 'local_hospital';
            case 'cake':
                return 'cake';
            case 'local_shipping':
                return 'local_shipping';
            case 'swap_horiz':
                return 'swap_horizontal_circle';
            default:
                return 'info';
        }
    }

    public gruppeZuweisen(): void {
        this.gruppeAendern(this.kieneTable.getSelectedRows());
    }

    getIconColor(bewegung_typ: string) {
        switch (bewegung_typ) {
            case 'login':
                return 'green';
            case 'logout':
                return 'red';
            case 'local_hospital':
                return 'black';
            case 'cake':
                return 'orange';
            default:
                return 'gray';
        }
    }

    private openTodMeldenDialog(tier: GruppeTier) {
        const dialogRef = this.dialog.open(GruppeTierTodMeldenComponent, { width: '25vw', data: { gruppeTier: tier } });
        dialogRef.afterClosed().subscribe({
            next: resp => {
                if (resp) {
                    this.tableService.reload();
                }
            },
        });
    }

    private openGruppeTierDialog(gruppeTier: GruppeTier) {
        const dialogRef = this.dialog.open(GruppeTierDetailsDialogComponent, {
            minWidth: '30vw',
            data: { tier: gruppeTier },
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.tableService.reload('openGruppeTierDialog');
                }
            },
        });
    }

    private openBemerkungDialog(gt: GruppeTier) {
        const dialogRef = this.dialog.open(GruppeTierBemerkungDialogComponent, { data: { tier: gt } });
        dialogRef.afterClosed().subscribe({
            next: () => {
                this.tableService.reload('openBemerkungDialog');
            },
        });
    }

    private gruppeAendernTier(gruppeTier: GruppeTier) {
        this.gruppeAendern([gruppeTier]);
    }

    private gruppeAendern(gruppeTiere: GruppeTier[]) {
        this.gruppeTierService.openGruppeAuswaehlenDialog(gruppeTiere).subscribe({
            next: (neueGruppe: Gruppe | null) => {
                if (neueGruppe) {
                    this.tableService.clearSelection();
                    this.tableService.reload('GruppeTier: gruppeAendern');
                }
            },
        });
    }

    private openAbgangStornierenDialog(gruppeTier: GruppeTier) {
        const confirmInput = new ConfirmDialogInput();
        confirmInput.headline = 'Abgang stornieren?';
        confirmInput.showCancel = true;
        confirmInput.cancelButton = 'Abbrechen';
        confirmInput.text = 'Wollen Sie den Abgang des Tieres wirklich stornieren?';
        confirmInput.okButton = 'Stornieren';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: confirmInput });
        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    this.gruppeTierService.abgangStornieren(gruppeTier).subscribe({
                        next: () => {
                            this.tableService.reload('openAbgangStornierenDialog');
                            this.messageService.infoMessage('Stornierungsmeldung wurde erzeugt!');
                        },
                        error: err => {
                            this.messageService.errorMessage('Fehler!', err);
                        },
                    });
                }
            },
        });
    }
}
